/**
 * All the JS for the maps
 */

export default () => {

  (function( $ ) {

    const offsetX = ($(window).outerWidth() > 767) ? $(window).outerWidth() / 2 : 0;

    const TILE_SIZE = { height: 256, width: 256 }; // google World tile size, as of v3.22
    const ZOOM_MAX = 21; // max google maps zoom level, as of v3.22
    const BUFFER = 15; // edge buffer for fitting markers within viewport bounds
    const mapDimensions = {};
    const mapOffset = {x:offsetX, y:0};

    /**
     * initMap
     *
     * Renders a Google Map onto the selected jQuery element
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @return  object The map instance.
     */
    function initMap( $el ) {

      // Find marker elements within map.
      const $markers = $el.find('.marker');
      const marker_colour = $el.data('colour');
      const single = $el.data('single');

      let styles = false;

      //if ( ! single ) {
        styles = [
          {
            "featureType": "all",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "weight": "2.00"
              }
            ]
          },
          {
            "featureType": "all",
            "elementType": "geometry.stroke",
            "stylers": [
              {
                "color": "#9c9c9c"
              }
            ]
          },
          {
            "featureType": "all",
            "elementType": "labels.text",
            "stylers": [
              {
                "visibility": "on"
              }
            ]
          },
          {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [
              {
                "color": "#f2f2f2"
              }
            ]
          },
          {
            "featureType": "landscape",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#ffffff"
              }
            ]
          },
          {
            "featureType": "landscape.man_made",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#ffffff"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
              {
                "color": "#f5f5f5"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "labels.text",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#dedede"
              },
              {
                "lightness": "21"
              },
              {
                "gamma": "1"
              },
              {
                "weight": "1"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
              {
                "saturation": -100
              },
              {
                "lightness": 45
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#ffe411"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#7b7b7b"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "labels.text.stroke",
            "stylers": [
              {
                "color": "#ffffff"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "simplified"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "labels.icon",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "all",
            "stylers": [
              {
                "color": "#46bcec"
              },
              {
                "visibility": "on"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#e9e9e9"
              }
            ]
          }
        ];
      //}

      // Create generic map.
      const mapArgs = {
        zoom        : $el.data('zoom') || 16,
        mapTypeId   : google.maps.MapTypeId.ROADMAP,
        styles      : styles,
        mapTypeControlOptions: {
          mapTypeIds: [google.maps.MapTypeId.ROADMAP]
        }, // here´s the array of controls
        mapTypeControl: false,
        scaleControl: true,
        zoomControl: true,
        streetViewControl: false,
        fullscreenControl: false,
        zoomControlOptions: {
          style: google.maps.ZoomControlStyle.LARGE
        },
      };
      const map = new google.maps.Map( $el[0], mapArgs );

      // Add markers.
      map.markers = [];
      $markers.each(function(){
        initMarker( $(this), map, marker_colour, single );
      });

      // Center map based on markers.
      centerMap( map );

      if ( ! single ) {
        // Set map bounds once map is ready
        google.maps.event.addListenerOnce(map, "projection_changed", function () {
          setMapBounds(map, $el[0]);
        });

      }

      // Return map instance.
      return map;
    }

    const setMapBounds = (map, el) => {
      updateMapDimensions(el);
      const bounds = new google.maps.LatLngBounds();
      map.markers.forEach(function( marker ){
        bounds.extend({
          lat: marker.position.lat(),
          lng: marker.position.lng()
        });
      });
      const dimensions = {
        width: mapDimensions.width - mapOffset.x - BUFFER * 2,
        height: mapDimensions.height - mapOffset.y - BUFFER * 2
      };
      const zoomLevel = getBoundsZoomLevel(bounds, dimensions);
      setTimeout(function (){
        map.setZoom(zoomLevel);
        setOffsetCenter(bounds.getCenter(), map);
      },50);
    };

    const updateMapDimensions = (el) => {
      mapDimensions.height = el.offsetHeight;
      mapDimensions.width = el.offsetWidth;
    };

    // Determines zoom level based on bounds
    const getBoundsZoomLevel = (bounds, dimensions) => {
      const latRadian = lat => {
        let sin = Math.sin(lat * Math.PI / 180);
        let radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
        return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
      };
      const zoom = (mapPx, worldPx, fraction) => {
        return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
      };
      const ne = bounds.getNorthEast();
      const sw = bounds.getSouthWest();
      const latFraction = (latRadian(ne.lat()) - latRadian(sw.lat())) / Math.PI;
      const lngDiff = ne.lng() - sw.lng();
      const lngFraction = ((lngDiff < 0) ? (lngDiff + 360) : lngDiff) / 360;
      const latZoom = zoom(dimensions.height, TILE_SIZE.height, latFraction);
      const lngZoom = zoom(dimensions.width, TILE_SIZE.width, lngFraction);
      return Math.min(latZoom, lngZoom, ZOOM_MAX);
    };


    const offsetLatLng = (latlng, offsetX, offsetY, map) => {
      offsetX = offsetX || 0;
      offsetY = offsetY || 0;
      const scale = Math.pow(2, map.getZoom());
      const point = map.getProjection().fromLatLngToPoint(latlng);
      const pixelOffset = new google.maps.Point((offsetX/scale), (offsetY/scale));
      const newPoint = new google.maps.Point(
        point.x - pixelOffset.x,
        point.y + pixelOffset.y
      );
      return map.getProjection().fromPointToLatLng(newPoint);
    };

    const setOffsetCenter = (latlng, map) => {
      const newCenterLatLng = offsetLatLng(latlng, mapOffset.x/2, mapOffset.y/2, map);
      map.panTo(newCenterLatLng);
    };


    /**
     * initMarker
     *
     * Creates a marker for the given jQuery element and map.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @param   object The map instance.
     * @return  object The marker instance.
     */
    function initMarker( $marker, map, marker_colour, single ) {

      // Get position from marker.
      const lat = $marker.data('lat');
      const lng = $marker.data('lng');
      const latLng = {
        lat: parseFloat( lat ),
        lng: parseFloat( lng )
      };

      const markerScale = ($(window).outerWidth() < 992) ? 0.65 : 1;

      const svgFile = '<svg width="27" height="37" viewBox="0 0 27 37" fill="none" xmlns="http://www.w3.org/2000/svg">'
                      +'<path d="M11.8125 35.6562C8.15625 31.0859 0 20.1875 0 14C0 6.54688 5.97656 0.5 13.5 0.5C20.9531 0.5 27 6.54688 27 14C27 20.1875 18.7734 31.0859 15.1172 35.6562C14.2734 36.7109 12.6562 36.7109 11.8125 35.6562ZM13.5 18.5C15.9609 18.5 18 16.5312 18 14C18 11.5391 15.9609 9.5 13.5 9.5C10.9688 9.5 9 11.5391 9 14C9 16.5312 10.9688 18.5 13.5 18.5Z" fill="#262626"/>'
                      +'</svg>';

      const svgMarker = {
        // path: "M43.159,23.14 C38.33,22.332 34.433,17.630 35.115,12.512 C35.798,7.393 40.505,3.798 45.630,4.479 C50.754,5.162 54.356,9.861 53.672,14.981 C52.992,20.98 48.284,23.696 43.159,23.14 ZM73.412,19.109 C62.250,26.479 45.212,44.185 39.124,75.383 C38.352,42.696 24.172,22.201 3.587,10.497 C14.24,12.571 35.822,17.13 41.961,38.330 C49.209,24.738 63.103,20.865 73.412,19.109 Z",
        // fillColor: marker_colour,
        // fillOpacity: 1,
        // strokeWeight: 1,
        // strokeColor: "rgb(244, 244, 245)",
        rotation: 0,
        scale: markerScale,
        anchor: new google.maps.Point(38, 35),
        url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgFile)
      };

      


      // Create marker instance.
      const marker = new google.maps.Marker({
        position : latLng,
        map: map,
        icon: svgMarker
      });

      // Append to reference for later use.
      map.markers.push( marker );

      // If marker contains HTML, add it to an infoWindow.
      if( $marker.html() ){

        // Create info window.
        const infowindow = new google.maps.InfoWindow({
          content: $marker.html()
        });

        // Show info window when marker is clicked.
        google.maps.event.addListener(marker, 'click', function() {
          infowindow.open( map, marker );
        });

        // If on the single view open the marker from the start
        if ( single ) {
          infowindow.open( map, marker );
        }

      }
    }

    /**
     * centerMap
     *
     * Centers the map showing all markers in view.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   object The map instance.
     * @return  void
     */
    function centerMap( map ) {

      // Create map boundaries from all map markers.
      const bounds = new google.maps.LatLngBounds();
      map.markers.forEach(function( marker ){
        bounds.extend({
          lat: marker.position.lat(),
          lng: marker.position.lng()
        });
      });

      // Case: Single marker.
      if( map.markers.length == 1 ){
        map.setCenter( bounds.getCenter() );

        // Case: Multiple markers.
      } else{
        map.fitBounds( bounds );
      }
    }


// Render maps on page load.
    $(document).ready(function(){
      $('.acf-map').each(function(){
        const map = initMap( $(this) );

        // // Create the search box and link it to the UI element.
        // const input = document.getElementById("location-search");
        // const searchBox = new google.maps.places.SearchBox(input);

        // // Bias the SearchBox results towards current map's viewport.
        // map.addListener("bounds_changed", () => {
        //   searchBox.setBounds(map.getBounds());
        // });

        // // Listen for the event fired when the user selects a prediction and retrieve
        // // more details for that place.
        // searchBox.addListener("places_changed", () => {
        //   const places = searchBox.getPlaces();

        //   if (places.length == 0) {
        //     return;
        //   }

        //   // For each place, get the icon, name and location.
        //   const bounds = new google.maps.LatLngBounds();

        //   places.forEach((place) => {
        //     if (!place.geometry || !place.geometry.location) {
        //       console.log("Returned place contains no geometry");
        //       return;
        //     }

        //     if (place.geometry.viewport) {
        //       // Only geocodes have viewport.
        //       bounds.union(place.geometry.viewport);
        //     } else {
        //       bounds.extend(place.geometry.location);
        //     }
        //   });

        //   const dimensions = {
        //     width: mapDimensions.width - mapOffset.x - BUFFER * 2,
        //     height: mapDimensions.height - mapOffset.y - BUFFER * 2
        //   };
        //   const zoomLevel = getBoundsZoomLevel(bounds, dimensions);
        //   setTimeout(function (){
        //     map.setZoom(zoomLevel);
        //     setOffsetCenter(bounds.getCenter(), map);
        //   },50);

        // });

      });
    });


  })(jQuery);

};
